module.exports = __webpack_public_path__ + "img/chevron-down.f24e2493.svg";